// Landing dashboards an HR admin can be sent to after login.
// The key is stored in tenants.default_dashboard (HR Admin add/edit form) and comes back
// as the last field of the hr_admin login string. Keep the keys in sync with
// Admin_model::DEFAULT_DASHBOARDS on the backend.
//
// `path` is relative to the tenant url (e.g. "t/acme/") and must point at a route that
// routes/index.js registers for that HR; `allowed` mirrors those route conditions so a
// dashboard the HR cannot open falls back to the standard dashboard.

const isFullPackage = (s) => s.pkg != null && s.pkg !== "0";

export const HR_DASHBOARDS = [
  { key: "", label: "Default Dashboard", path: "dashboard", allowed: () => true },
  { key: "leave", label: "Leave Dashboard", path: "leave-dashboard", allowed: () => true },
  { key: "attendance", label: "Attendance Dashboard", path: "attendance-dashboard", allowed: () => true },
  { key: "payroll", label: "Payroll Dashboard", path: "payroll-dashboard", allowed: isFullPackage },
  { key: "employee", label: "Employee Dashboard", path: "employee-dashboard", allowed: () => true },
];

const DEFAULT_PATH = "dashboard";

/**
 * Path (relative to the tenant url) an HR admin lands on after login.
 * Unknown / unset / not-permitted dashboards fall back to the standard dashboard.
 */
export function resolveHrDashboardPath({ key, loginType, pkg, custom }) {
  // Only HR admins have a configured dashboard; "custom" tenants get the custom report
  // layout where every standard route is disabled, so keep their existing behaviour.
  if (loginType !== "hr_admin" || custom === "1") return DEFAULT_PATH;
  const dashboard = HR_DASHBOARDS.find((d) => d.key === (key || ""));
  if (!dashboard || !dashboard.allowed({ pkg })) return DEFAULT_PATH;
  return dashboard.path;
}
